const { Component, render, findDOMNode, Fragment } = wp.element;

const alias = 'Comparison_Tables-Carousel-'
class Comparison_Tables_Carousel extends Component {

  constructor(props) {
    super(props);

    this.state = {
      index: 0
    }

    this.totals = ( this.props.items.length - 1 );
  }

  render()
  {
    const { items } = this.props;
    const { index } = this.state;

    return <div className={ `${alias}wrapper` }>
      
      { items.length > 1 ? <span className="ct-arrow-left" onClick={ e => {
        let new_index = index - 1;
        if( new_index < 0 ){
          new_index = this.totals;
        }

        this.setState({
          index: new_index
        });

      }}></span> : '' }

      { items.length > 1 ? <span className="ct-arrow-right" onClick={ e => {
        let new_index = index + 1;
        if( new_index > this.totals ){
          new_index = 0;
        }

        this.setState({
          index: new_index
        });

      }}></span> : '' }

      <a target="_blank" href={ this.props.url }><img src={ items[index] } /></a>
    </div>
  }
}

export { Comparison_Tables_Carousel };


// WEBPACK FOOTER //
// ./src/carousel.js